/* ProjectLP — theme JS: mobile nav, cart count refresh after AJAX add */
(function () {
  'use strict';

  // Mobile nav toggle
  const toggle = document.querySelector('.mobile-nav-toggle');
  const nav = document.querySelector('.nav-split');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Refresh cart count on AJAX add events
  async function refreshCartCount() {
    try {
      const res = await fetch(window.theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = '· ' + cart.item_count;
      });
    } catch (e) {}
  }
  document.addEventListener('cart:added', refreshCartCount);

  // Keep French / German visitors in their language: links typed as "/pages/..." in section settings
  // and templates don't carry the /fr or /de prefix, so add it (Shopify's own links already have it).
  const root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  if (root !== '/') {
    document.querySelectorAll('a[href^="/"]').forEach(a => {
      const href = a.getAttribute('href');
      if (href.startsWith('//') || href === root || href.startsWith(root + '/') || href.startsWith(root + '?')) return;
      if (/^\/(cdn|checkout|checkouts|account|services|apps|tools)(\/|$|\?)/.test(href)) return;
      a.setAttribute('href', root + href);
    });
  }

  // Wire any non-configurator product forms to AJAX too (optional, gentle)
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      const submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;
      // Allow the default native submit for now to preserve checkout flow on non-JS.
      // (To switch to AJAX, uncomment below.)
      // e.preventDefault();
      // const data = new FormData(form);
      // const items = { id: data.get('id'), quantity: 1 };
      // try { await fetch(window.theme.routes.cartAdd, { method:'POST', body: JSON.stringify({ items:[items] }), headers:{'Content-Type':'application/json'} }); document.dispatchEvent(new CustomEvent('cart:added')); window.location.href = window.theme.routes.cart; } catch(err) {}
    });
  });
})();
